import { useState } from 'react';
import { Bookmark } from 'lucide-react';

export function SaveButton({
  isSaved,
  onSave,
  onUnsave,
}: {
  isSaved: boolean;
  onSave: () => Promise<unknown>;
  onUnsave: () => Promise<unknown>;
}) {
  const [optimistic, setOptimistic] = useState<boolean | null>(null);
  const [pending, setPending] = useState(false);
  const saved = optimistic ?? isSaved;

  const onClick = async () => {
    if (pending) return;
    const next = !saved;
    setOptimistic(next);
    setPending(true);
    try {
      await (next ? onSave() : onUnsave());
    } catch {
      setOptimistic(saved);
    } finally {
      setPending(false);
    }
  };

  return (
    <button
      type="button"
      aria-label={saved ? 'Unsave' : 'Save'}
      aria-pressed={saved}
      onClick={onClick}
      className="flex items-center justify-center w-9 h-9 rounded-lg text-foreground active:bg-accent focus:outline-none"
    >
      <Bookmark size={20} fill={saved ? 'currentColor' : 'none'} />
    </button>
  );
}
